(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5411973"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('mjny-category-carousel')) return;

  class CategoryCarousel extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.arrows = Array.from(this.querySelectorAll('[data-move]'));
      this.scrubber = this.querySelector('.cc-scrubber');
      this.scrubberThumb = this.querySelector('.cc-scrubber-thumb');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.tabs[next].focus();
          this.activate(this.tabs[next].dataset.tab);
        }, options);
      });
      this.arrows.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.move)), options));
      // scroll does not bubble, capture catches it from every track
      this.addEventListener('scroll', () => this.updateArrows(), { ...options, capture: true, passive: true });
      this.resizer = new ResizeObserver(() => this.updateArrows());
      this.resizer.observe(this);
      this.bindDrag(options);
      this.activate(this.panels[0]?.dataset.panel);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.resizer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    activate(value) {
      this.tabs.forEach(tab => {
        const selected = tab.dataset.tab === value;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.panel !== value;
        if (!panel.hidden) panel.querySelector('.cc-track').scrollLeft = 0;
      });
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.updateArrows());
    }

    get track() {
      return this.panels.find(panel => !panel.hidden)?.querySelector('.cc-track');
    }

    // Arrows move one "page" of fully visible cards
    move(direction) {
      const track = this.track;
      if (!track) return;
      const card = track.querySelector('.cc-card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / step));
      const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * perPage * step, behavior: smooth ? 'smooth' : 'auto' });
    }

    // Arrows only show when there is somewhere to go; the bar mirrors the scroll position
    updateArrows() {
      const track = this.track;
      const max = track ? Math.max(0, track.scrollWidth - track.clientWidth) : 0;
      this.arrows.forEach(button => {
        const back = Number(button.dataset.move) < 0;
        button.hidden = max <= 1 || (back ? track.scrollLeft <= 1 : track.scrollLeft >= max - 1);
        if (track) button.setAttribute('aria-controls', track.parentElement.id);
      });
      const image = track?.querySelector('.cc-image');
      if (image) this.style.setProperty('--cc-arrow-top', `${image.offsetTop + image.offsetHeight / 2}px`);

      this.scrubber.hidden = max <= 1;
      if (max <= 1) return;
      const thumbWidth = track.clientWidth / track.scrollWidth;
      const progress = track.scrollLeft / max;
      this.scrubberThumb.style.setProperty('--cc-thumb-w', `${thumbWidth * 100}%`);
      this.scrubberThumb.style.setProperty('--cc-thumb-x', `${progress * (1 / thumbWidth - 1) * 100}%`);
    }

    // Mouse drag (touch already scrolls natively)
    bindDrag(options) {
      let drag = null;
      this.addEventListener('pointerdown', event => {
        const track = event.target.closest('.cc-track');
        if (!track || event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { track, x: event.clientX, left: track.scrollLeft, moved: false };
      }, options);
      window.addEventListener('pointermove', event => {
        if (!drag) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          drag.track.classList.add('is-dragging');
        }
        drag.track.scrollLeft = drag.left - dx;
      }, options);
      window.addEventListener('pointerup', () => {
        if (!drag) return;
        const { track, moved } = drag;
        drag = null;
        if (!moved) return;
        track.classList.remove('is-dragging');
        // swallow the click that ends a drag so cards don't open
        const swallow = event => { event.preventDefault(); event.stopPropagation(); };
        track.addEventListener('click', swallow, true);
        setTimeout(() => track.removeEventListener('click', swallow, true), 50);
      }, options);
    }
  }

  customElements.define('mjny-category-carousel', CategoryCarousel);
})();
  } catch(e) { console.error(e); }
})();

})();
